import {
	get,
	post
} from './http'

export default {
	firstBinding(fromparams, openid) {
		return get('Sales/firstBinding', {
			fromparams: fromparams,
			openid: openid
		});
	},
	getSalesReport(StartDate, EndDate, DateType, FromParams, OpenId = '') {
		return get('Sales/getSalesReport', {
			start: StartDate,
			end: EndDate,
			datetype: DateType,
			fromparams: FromParams,
			openid: OpenId
		});
	}
}



// WEBPACK FOOTER //
// ./src/request/salesApi.js